export default __webpack_public_path__ + "static/media/search.30092207.png";